export default __webpack_public_path__ + "static/media/skymagic.5a0b8302.png";